import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function DestinationList({ destinations }) {
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 3;
  const pageVisited = pageNumber * usersPerPage;
  const displayUser = destinations
    .slice(pageVisited, pageVisited + usersPerPage)
    .map((item, index) => {
      return (
        <div
          className="row destinationBox"
          key={index}
        >
          <div className="col-lg-6 col-12 col-md-6 destinationImage">
            <img className="img-fluid" src={item.image} alt="" />
          </div>
          <div className="col-lg-6 col-12 col-md-6 destinationText">
            <h5 className="title">{item.name}</h5>
            <p>{item.description}</p>
            <Link to={`/destination/${item.id}`}>
              Xem thêm
              <img className="img-fluid" src="/images/ic_arrow2.png" alt="" />
            </Link>
          </div>
        </div>
      );
    });
  const pageCount = Math.ceil(destinations.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  return (
    <div className="destinationList">
      {displayUser}
      <ReactPaginate
        previousLabel={<FontAwesomeIcon icon="angle-left" />}
        nextLabel={<FontAwesomeIcon icon="angle-right" />}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"pagination"}
        previousLinkClassName={"reviousBtn"}
        nextLinkClassName={"nextBtn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
    </div>
  );
}
export default DestinationList;
